import * as React from "react";
import {useLocation} from "react-router";

export const useLocationQuery = () => {
    const {search} = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
};
